import ProtectedRoute from '../auth/ProtectedRoute';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { Root } from '../components/Root';
import { AboutPage } from '../pages/AboutPage';
import { JobsPage } from '../pages/JobsPage';
import { JobPage } from '../pages/JobPage';
import { FilesPage } from '../pages/FilesPage';
import { ErrorPage } from '../pages/ErrorPage';
import { LoggedOutPage } from '../pages/LoggedOutPage';
import { AccessDeniedPage } from '../pages/AccessDeniedPage';
import { AdminPage } from '../pages/AdminPage';

const isTestEnv = process.env.REACT_APP_CI === 'true';

export const router = createBrowserRouter([
  {
    path: '/',
    element: isTestEnv? <Root/>: <ProtectedRoute><Root/></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/jobs" />
      },
      {
        path: 'jobs', 
        element: <JobsPage/>
      },
      {
        path: 'jobs/:id',
        element: <JobPage />
      },
      {       
        path: 'about',
        element: <AboutPage/>
      },
      // {       
      //   path: 'files',
      //   element: <FilesPage/>
      // },
      {
        path: 'admin',
        element: <AdminPage/>,
      },
      {
        path: "*",
        element: <ErrorPage/>
      }
    ]
  },
  {
    path: '/logged_out',
    element: <LoggedOutPage />
  },
  {
    path: '/access-denied',
    element: <AccessDeniedPage />
  }
]);